import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "4",
  height: "18",
  fill: "none",
  viewBox: "0 0 4 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("circle", {
      cx: "2",
      cy: "2",
      r: "2",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "2",
      cy: "9",
      r: "2",
      fill: "currentColor"
    }, null, -1),
    _createElementVNode("circle", {
      cx: "2",
      cy: "16",
      r: "2",
      fill: "currentColor"
    }, null, -1)
  ]))]))
}
export default { render: render }